export default "__VITE_ASSET__B8349c3B__"